import { FuseUtils } from '@fuse'
import * as R from 'ramda'

export const GET_NAVIGATION = '[NAVIGATION] GET NAVIGATION'
export const SET_NAVIGATION = '[NAVIGATION] SET NAVIGATION'
export const UPDATE_NAVIGATION_ACCESS_CONTROL =
  '[NAVIGATION] UPDATE NAVIGATION ACCESS CONTROL'
export const RESET_NAVIGATION = '[NAVIGATION] RESET NAVIGATION'

export function getNavigation() {
  return {
    type: GET_NAVIGATION,
  }
}

export function updateNavigationAccessControl(permissionInfo) {
  return {
    type: UPDATE_NAVIGATION_ACCESS_CONTROL,
    permissionInfo,
  }
}

export function setNavigation(navigation) {
  return {
    type: SET_NAVIGATION,
    navigation,
  }
}

export function resetNavigation() {
  return {
    type: RESET_NAVIGATION,
  }
}

export function appendNavigationItem(item, parentId) {
  return (dispatch, getState) => {
    const { navigation } = getState().fuse
    return dispatch({
      type: SET_NAVIGATION,
      navigation: FuseUtils.appendNavItem(navigation, item, parentId),
    })
  }
}

export function prependNavigationItem(item, parentId) {
  return (dispatch, getState) => {
    const { navigation } = getState().fuse
    return dispatch({
      type: SET_NAVIGATION,
      navigation: FuseUtils.prependNavItem(navigation, item, parentId),
    })
  }
}

export function updateNavigationItem(id, item) {
  return (dispatch, getState) => {
    const { navigation } = getState().fuse
    return dispatch({
      type: SET_NAVIGATION,
      navigation: FuseUtils.updateNavItem(navigation, id, item),
    })
  }
}

export function removeNavigationItem(id) {
  return (dispatch, getState) => {
    const { navigation } = getState().fuse
    return dispatch({
      type: SET_NAVIGATION,
      navigation: FuseUtils.removeNavItem(navigation, id),
    })
  }
}

export function setNavigationWithPath(path) {
  return (dispatch, getState) => {
    const { navigation } = getState().fuse
    const newNavigation = R.map((item) => {
      let selectedItem = false
      const selected = R.find((navigationItem) => {
        return navigationItem.url === path
      })(item.children)

      if (selected) {
        item.children.map((navigationSubItem) => {
          navigationSubItem.isSelected = navigationSubItem.url === path
          return navigationSubItem
        })
        selectedItem = !!selected
      } else {
        item.children.map((subItem) => {
          if (subItem.children) {
            const subItemSelected = R.find((navigationSubItem) => {
              return navigationSubItem.url === path
            })(subItem.children)

            if (subItemSelected) {
              selectedItem = true
            }
            subItem.isSelected = subItemSelected ? true : false
          }
          return subItem
        })
      }
      item.isSelected = selectedItem
      return item
    })(navigation)

    return dispatch({
      type: SET_NAVIGATION,
      navigation: newNavigation,
    })
  }
}

export function onClickNavigation(navigationId) {
  return async (dispatch, getState) => {
    const { navigation } = getState().fuse
    const newNavigation = await R.map((item) => {
      item.isSelected = item.id === navigationId

      return item
    })(navigation)

    return await dispatch({
      type: SET_NAVIGATION,
      navigation: newNavigation,
    })
  }
}
